"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
var Logging_1 = require("../../../Logging");
var ReactNativeMobileDevicePlugin = (function (_super) {
    __extends(ReactNativeMobileDevicePlugin, _super);
    function ReactNativeMobileDevicePlugin(applyingOptionalDataControls) {
        var _this = _super.call(this) || this;
        _this.logger = new Logging_1.LogProvider("ReactNative-DeviceInfo");
        _this.logger.debug("Running from Bundle. NOOP.");
        return _this;
    }
    ReactNativeMobileDevicePlugin.prototype.processTelemetry = function (env, itemCtx) { };
    return ReactNativeMobileDevicePlugin;
}(_1ds_core_js_1.BaseTelemetryPlugin));
exports["default"] = ReactNativeMobileDevicePlugin;
//# sourceMappingURL=ReactNativeMobileDevicePlugin.js.map